import $ from 'jquery';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import ReactOnRails from 'react-on-rails';

import '../../../assets/javascripts/clickHandlers';
import '../../../assets/styles/home.scss';
import './accessible_video.js';
import './bootstrap_carousel.js';
import './tabslet.js';

import PreNavigationBanner from '../../Shared/components/shared/preNavigationBannerApp';
import StudentsOnlineNavbarButton from '../../Teacher/startup/StudentsOnlineNavbarButtonLazyClient';

ReactOnRails.register({ PreNavigationBanner });

document.onreadystatechange = () => {
  const state = document.readyState;
  if (state === 'complete') {
    $('tabs-teacher-stories').tabslet({
      autorotate: true,
      delay: 10000,
      pauseonhover: true,
      animation: true,
      active: 1,
    });

    $('.tabs-testimonials').tabslet({
      autorotate: true,
      delay: 10000,
      pauseonhover: false,
      animation: true,
      active: 1,
    });
  }
};

// Rendered by the shared teacher sub-header, so every ReactOnRails bundle must know it
ReactOnRails.register({ StudentsOnlineNavbarButton });
